export var CommonFlags;
(function (CommonFlags) {
    CommonFlags.SELECTION_CHANGE_INTEROP_NOTIFICATION_PAUSED = 'SELECTION_CHANGE_INTEROP_NOTIFICATION_PAUSED';
    CommonFlags.MODEL_CHANGE_INTEROP_NOTIFICATION_PAUSED = 'MODEL_CHANGE_INTEROP_NOTIFICATION_PAUSED';
})(CommonFlags || (CommonFlags = {}));
//# sourceMappingURL=common-flags.js.map